/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { trackEvent } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { emitCustomTrackingEvent } from '../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import useClickStreamCustomEventsTracking from '../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import { useDepartmentPageTracking, useIsDepartmentPageTrackingActive } from '../../../helpers/tracking/page/DepartmentPageTrackingContext';

export function useUniversalFeatureTracking() {
    const dispatch = useDispatch();
    const trackDepartmentPage = useDepartmentPageTracking();
    const isDepartmentPageTrackingActive = useIsDepartmentPageTrackingActive();

    return (item, gaConstants = {}) => {
        const title = item?.link?.title;
        const path = item?.link?.href;
        const label = item?.tracking_event_label || title?.split(' ')?.join('-')?.toLowerCase() || '';

        if (isDepartmentPageTrackingActive) {
            trackDepartmentPage(title || label || 'Universal Component');
            return;
        }

        dispatch(emitCustomTrackingEvent({
            action: 'Click',
            eventSubType: 'feature-tracking',
            category: item?.tracking_event_category || gaConstants?.tracking_event_category || 'Browse',
            label,
            link: path || '',
            tag: item?.tracking_event_action || '',
        }));
    };
}

export default function universalHandleClick(salesforceResponse) {
    const dispatch = useDispatch();
    const history = useHistory();
    const trackFeatureClick = useUniversalFeatureTracking();
    const trackClickThrough = useClickStreamCustomEventsTracking({
        salesforceResponse,
        isFireImpression: salesforceResponse?.campaign,
        page: { type: 'home' },
    });
    const handleClick = (item, gaConstants = {}) => {
        const path = item?.link?.href;
        const title = item?.link?.title;

        // If no path and no title, don't trigger the click event
        if (!path && !title) {
            return;
        }

        dispatch(trackEvent({
            eventCategory: item?.tracking_event_category || gaConstants?.tracking_event_category || '',
            eventAction: item?.tracking_event_action || gaConstants?.tracking_event_action || '',
            eventLabel: item?.tracking_event_label || '',
        }));
        trackFeatureClick(item, gaConstants);
        if (path?.includes('://')) {
            window.location.href = path;
        } else {
            history.push(path);
        }
        trackClickThrough();
    };
    return handleClick;
}
